module.exports = __webpack_public_path__ + "static/shadows@3x-236281b1508cbf29a328e10fc14180b0.png";